import { gql } from '@apollo/client';

const GET_CITY_LINK = gql`
  query GET_CITY_LINK($id: String) {
    city: boatnew_booking(where: { id: { _eq: $id } }) {
      tour_date
      tour_time
      customer {
        contactName: contact_name
        phone
        secondaryPhone: secondary_phone
      }
      product {
        name
        citiesProducts: cities_products {
          city {
            gmbLink: gmb_link
          }
        }
      }
      guide {
        full_name
        phone
      }
    }
  }
`;
const GET_REVIEW_STATUS = gql`
  query GET_REVIEW_STATUS($id: String) {
    review: logs_review_message_record(
      where: { booking_id: { _eq: $id }, review_status: { _eq: "PENDING" } }
    ) {
      reviewStatus: review_status
    }
  }
`;
interface GET_CITY_LINK_INTERFACE {
  city: [
    {
      tour_date: string;
      tour_time: string;
      customer: {
        contactName: string;
        phone: string;
        secondaryPhone: string;
      };
      product: {
        name: string;
        citiesProducts: {
          city: {
            gmbLink: string;
          };
        };
      };
      guide: {
        full_name: string;
        phone: string;
      };
    }
  ];
}
interface GET_REVIEW_STATUS_INTERFACE {
  review: [
    {
      reviewStatus: string;
    }
  ];
}
export { GET_CITY_LINK, GET_REVIEW_STATUS };
export type { GET_CITY_LINK_INTERFACE, GET_REVIEW_STATUS_INTERFACE };
